import React, { useState, useRef } from "react";
import { useVeltClient } from "../context";
export function useActivityUtils() {
    var _a = React.useState(), activityElement = _a[0], setActivityElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || activityElement)
            return;
        var loadedActivityElement = client.getActivityElement();
        setActivityElement(loadedActivityElement);
    }, [client, setActivityElement, activityElement]);
    return activityElement;
}
export function useAllActivities(config) {
    var activityElement = useActivityUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef();
    // Memoize the inputs
    var memoizedConfig = React.useMemo(function () {
        return config;
    }, [JSON.stringify(config)]);
    React.useEffect(function () {
        if (!activityElement)
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = activityElement.getAllActivities(memoizedConfig)
            .subscribe(function (activities) {
            setData(activities);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [activityElement === null || activityElement === void 0 ? void 0 : activityElement.getAllActivities, memoizedConfig]);
    return data;
}
